<ng-container *ngIf="mode === 'ReadOnly'; then read; else edit"></ng-container>
<ng-template #read>

    <portal-contact-item-picker [entity]="$safeNavigationMigration(control?.value)" />

</ng-template>
<ng-template #edit>

    <ng-select groupBy="group" [searchFn]="searchFn" [items]="data$ | async" [placeholder]="placeholder" [searchable]="true" [formControl]="control" [multiple]="multiple" [dropdownPosition]="dropdownPosition">
        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
            <div class="ng-value" *ngFor="let item of items">
                <portal-contact-item-picker (clear)="clear(item)" [clearTemplate]="true" [entity]="item" />
            </div>
        </ng-template>
        <ng-template ng-label-tmp let-item="item" let-index="index">
            <portal-contact-item-picker [entity]="item" />
        </ng-template>
        <ng-template ng-option-tmp let-item="item" let-index="index">
            <portal-contact-item-picker [entity]="item" />
        </ng-template>
    </ng-select>

</ng-template>


<ng-template #emptyField>
    <span class="empty-field">{{ emptyText }}</span>
</ng-template>